// Brand and content tokens — swap BRAND to rename the venue across the whole site.
export const BRAND = {
  name: "TEMPA",
  parts: ["Tempa", "health"],
  city: "West Perth",
  address: "299 Fitzgerald Street, West Perth, WA",
  parent: "Pedal Pop",
};

export const IMAGES = {
  logo: "/assets/logo.png",
  saunaHero: "/assets/sauna-hero.png",
  combo: "/assets/hero-combo.png",
  lake: "/assets/hero-lake.png",
  logo: "/assets/logo.png",
  expScene: "/assets/exp-main.png",
  expCutHeat: "/assets/exp-cut-heat-glow.png",
  expCutCold: "/assets/exp-cut-cold-glow.png",
  expCutReset: "/assets/exp-cut-reset-glow.png",
  expHeat: "/assets/exp-sauna.png",
  expCold: "/assets/exp-icebath.png",
  expReset: "/assets/exp-recovery.webp",
  heroSauna: "/assets/sauna-pink.webp",
  heroCold: "/assets/ice-bath.png",
  heat: "/assets/sauna-amber-1.webp",
  cold: "/assets/ice-bath.png",
  reset:
    "https://images.unsplash.com/photo-1778658684756-99d7b7460c87?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxwZW9wbGUlMjByZWxheGluZyUyMHdlbGxuZXNzJTIwc3BhJTIwcmVzb3J0fGVufDB8fHx8MTc4Nzk3OTc3NXww&ixlib=rb-4.1.0&q=85",
  redLight: "/assets/redlight-cut.png",
  social: "/assets/private-social.jpg",
  recoveryPop: "/assets/recovery-pop.png",
};
export const BOOKING = {
  book: "https://book.tempa.health/book",
  pedalPop: "https://book.tempa.health/pedal-pop",
  memberships: "https://book.tempa.health/memberships",
  account: "https://book.tempa.health/account",
};



export const NAV_LINKS = [
  { label: "Experience", href: "#experience", testid: "nav-experience" },
  { label: "How it works", href: "#how-it-works", testid: "nav-how-it-works" },
  { label: "Pricing", href: "#pricing", testid: "nav-pricing" },
  { label: "Safety", href: "#safety", testid: "nav-safety" },
  { label: "Location", href: "#location", testid: "nav-location" },
];
